/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';
import { ButtonStroke } from '@blink/components';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonSize } from '@blink/components/src/Button/Button.types';
import { shortFormatNumber } from '@blink/components/src/utils';

import { useUserVaultsRowsStyle } from './UserVaultsRows.style';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { Store } from '@/shared/store';
import { UserVault } from '@/shared/store/userVaults';
import { ROLE } from '@/shared/api/vault';
import { formatSmart } from '@/shared/utils/helpers';
import { AssetWithIcon } from '@/shared/ui';

type UserVaultsRowsProps = {
    items: UserVault[];
};

export const UserVaultsRows: FC<UserVaultsRowsProps> = ({ items }) => {
    const classes = useUserVaultsRowsStyle();
    const dispatch = useDispatch();

    const { vaults } = useSelector((state: Store) => ({
        vaults: state.vaults.vaults,
    }));

    //const refreshVAults = async () => dispatch(getVaultsAction(ROLE.LENDER));

    if (!items) {
        return null;
    }

    return (
        <>
            {items.map((item, index) => {
                const vault = vaults.find(
                    (v) => v.role === ROLE.INVESTOR && v.address === item.address,
                );

                const netApy = Number(item.netApy || '0').toFixed(2);
                const formatedNetApy = Number(netApy);

                const handleWithdraw = () => {
                    dispatch(
                        showModalAction({
                            modalName: ModalName.VAULT_WITHDRAWAL_MODAL,
                            modalTitle: 'Withdraw Liquidity',
                            modalProps: {
                                balance: item.balance,
                                currentApy: Number(item.apy),
                                totalDeposited: item.totalDeposited,
                                totalDepositThreshold: shortFormatNumber({
                                    amount: Number(item.totalDepositThreshold),
                                }),
                                isWithdraw: true,
                                agreementAddress: item.address,
                                tokenAddress: item.tokenAddress,
                                tokenSymbol: item.tokenSymbol,
                                decimals: item.tokenDecimals,
                                interestClaimable: vault!.interestClaimable,
                                totalPosition: vault!.totalPosition,
                                interestAccrued: vault!.interestAccrued,
                                poolUtilization: vault!.poolUtilization,
                                poolBalance: vault!.poolBalance,
                                netApy: netApy,
                            },
                        }),
                    );
                };
                return (
                    <tr key={index} className={classes.tr}>
                        <td>{item.title}</td>
                        <td>
                            <AssetWithIcon assetName={item.tokenSymbol || 'DAI'} />
                        </td>
                        <td className={classes.balance}>
                            <div>
                                {formatSmart(item.balance!)}
                                <span className='font-normal ml-2'>{item.tokenSymbol}</span>
                            </div>
                        </td>
                        <td>{Number.isNaN(formatedNetApy) ? 'N/A' : `${formatedNetApy} %`}</td>
                        <td>{item.curator}</td>
                        <td>
                            <div>
                                {formatSmart(item.reward!)}
                                <span className='font-normal ml-2'>{item.tokenSymbol}</span>
                            </div>
                        </td>
                        <td className={classes.buttonTd}>
                            <div className='flex items-end'>
                                <ButtonStroke
                                    size={ButtonSize.md}
                                    className={classes.button}
                                    isPrimary
                                    onClick={handleWithdraw}
                                >
                                    Withdraw
                                </ButtonStroke>
                            </div>
                        </td>
                    </tr>
                );
            })}
        </>
    );
};
